import s from './Line.module.scss';

const Line = () => {
  return (
    <div className={s.line}>
      <div className={s.marquee}>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
      </div>
      <div className={s.marquee}>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
        <span>WARNING: THIS IS NOT A MEME COIN</span>
      </div>
    </div>
  );
};

export default Line;
